import Audit from './Audit'
import CertifiedPackage from './CertifiedPackage'
import ChangeAccount from './ChangeAccount'
import ChangeShop from './ChangeShop'
import CheckGreen from './CheckGreen'
import CheckRed from './CheckRed'
import Chrono2h from './Chrono2h'
import Chrono2hBold from './Chrono2hBold'
import ChronoHalfDay from './ChronoHalfDay'
import ChronoHalfDayBold from './ChronoHalfDayBold'
import ChronoTenMinBold from './ChronoTenMinBold'
import DeliveryPerson from './DeliveryPerson'
import DexisEngagement from './DexisEngagement'
import Drop from './Drop'
import { Email } from './Email'
import EqualCircle from './EqualCircle'
import Facebook from './Facebook'
import France from './France'
import Hands from './Hands'
import HydraliansEngagement from './HydraliansEngagement'
import Instagram from './Instagram'
import Linkedin from './Linkedin'
import ListIllustration from './List'
import LoyaltyProliansTag from './LoyaltyProliansTag'
import LoyaltyStar from './LoyaltyStar'
import LoyaltyStarBold from './LoyaltyStarBold'
import Netherlands from './Netherlands'
import Package from './Package'
import PlayCircle from './PlayCircle'
import PlusCircle from './PlusCircle'
import PointerArrow from './PointerArrow'
import ProliansEngagement from './ProliansEngagement'
import ServePlate from './ServePlate'
import Service from './Service'
import { ShoppingBasket } from './ShoppingBasket'
import { SimplePackage } from './SimplePackage'
import { Smile } from './Smile'
import Store from './Store'
import Tools from './Tools'
import ToolsBold from './ToolsBold'
import Truck from './Truck'
import Youtube from './Youtube'

const illustrations = {
  audit: Audit,
  'certified-package': CertifiedPackage,
  'change-account': ChangeAccount,
  'change-shop': ChangeShop,
  'check-green': CheckGreen,
  'check-red': CheckRed,
  'chrono-2h-bold': Chrono2hBold,
  'chrono-2h': Chrono2h,
  'chrono-half-day-bold': ChronoHalfDayBold,
  'chrono-half-day': ChronoHalfDay,
  'chrono-ten-min-bold': ChronoTenMinBold,
  'delivery-person': DeliveryPerson,
  'dexis-engagement': DexisEngagement,
  drop: Drop,
  'equal-circle': EqualCircle,
  facebook: Facebook,
  email: Email,
  france: France,
  hands: Hands,
  'hydralians-engagement': HydraliansEngagement,
  instagram: Instagram,
  linkedin: Linkedin,
  list: ListIllustration,
  'loyalty-prolians-tag': LoyaltyProliansTag,
  'loyalty-star-bold': LoyaltyStarBold,
  netherlands: Netherlands,
  'loyalty-star': LoyaltyStar,
  package: Package,
  'play-circle': PlayCircle,
  'plus-circle': PlusCircle,
  'pointer-arrow': PointerArrow,
  'prolians-engagement': ProliansEngagement,
  'serve-plate': ServePlate,
  service: Service,
  'shopping-basket': ShoppingBasket,
  'simple-package': SimplePackage,
  smile: Smile,
  store: Store,
  'tools-bold': ToolsBold,
  tools: Tools,
  truck: Truck,
  youtube: Youtube,
} as const

export const illustrationNames = Object.keys(illustrations) as Array<keyof typeof illustrations>

export type IllustrationName = (typeof illustrationNames)[number]

export function isIllustrationName(name: string): name is IllustrationName {
  return illustrationNames.some((illustrationName) => illustrationName === name)
}

export type IllustrationProps = UiComponentProps<{
  name: IllustrationName
  'aria-hidden'?: React.AriaAttributes['aria-hidden']
}>

export function Illustration({ name, ...rest }: IllustrationProps): React.ReactElement | undefined {
  const Component = illustrations[name]

  if (!Component) return undefined

  return <Component {...rest} />
}
